import { render, staticRenderFns } from "./message-audio.vue?vue&type=template&id=1296eba0&scoped=true"
import script from "./message-audio.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-audio.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-audio.vue?vue&type=style&index=0&id=1296eba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1296eba0",
  null
  
)

export default component.exports